import {
  Tooltip as KendoToolTip,
  TooltipPosition,
} from "@progress/kendo-react-tooltip";
import React, { PropsWithChildren } from "react";
import PremiumDiamondIcon from "@/icons/premium_diamond.svg?react";

import "./styles.scss";

export const getPremiumTooltipContent = ({
  title = "Please upgrade to enable this feature.",
} = {}) =>
  function TooltipContentComponent() {
    return (
      <div
        style={{
          backgroundColor: "var(--tlx-color-icon-muted)",
          color: "var(--tlx-surface-bg-surface)",
          maxWidth: "28.125rem",
          padding: "0.8125rem 1rem",
          borderRadius: "var(--tlx-radius-lg)",
          display: "flex",
          gap: "var(--tlx-space-1)",
        }}
      >
        <PremiumDiamondIcon />
        <p style={{ margin: "0", fontWeight: 500 }}>{title}</p>
      </div>
    );
  };

const ToolTip: React.FC<
  {
    title?: string;
    isFreemium?: boolean;
    anchorElement?: string;
    id?: string;
    parentTitle?: boolean;
    disabled?: boolean;
    freemiumTooltipTitle?: string;
    position?: TooltipPosition;
    style?: React.CSSProperties;
    showCallout?: boolean;
  } & PropsWithChildren
> = props => {
  return (
    <KendoToolTip
      // Approved app-wide tooltip design (matches the Data Source Name / table
      // cell tooltip): anchored to the target with a callout arrow. Callers can
      // still override either.
      anchorElement={props.anchorElement || "target"}
      position={props.position || "auto"}
      tooltipClassName={props.isFreemium ? "tooltip-freemium-enabled" : ""}
      content={
        props.isFreemium
          ? getPremiumTooltipContent({ title: props.freemiumTooltipTitle })
          : undefined
      }
      id={props.id}
      parentTitle={props.parentTitle}
      filter={() => !props.disabled}
      style={props.style}
      showCallout={props.showCallout ?? true}
    >
      <span
        className="kendo-custom-tooltip"
        title={props.title}
        style={{ display: "inherit", width: "100%" }}
      >
        {props.children}
      </span>
    </KendoToolTip>
  );
};

export const ToolTipSimple: React.FC<
  {
    title?: string;
    anchorElement?: string;
    id?: string;
    parentTitle?: boolean;
    position?: TooltipPosition;
    style?: React.CSSProperties;
    showCallout?: boolean;
  } & PropsWithChildren
> = props => {
  return (
    <KendoToolTip
      // Approved app-wide tooltip design: anchored to the target with a callout
      // arrow (matches the Data Source Name tooltip). Callers can override.
      anchorElement={props.anchorElement || "target"}
      position={props.position || "auto"}
      id={props.id}
      parentTitle={props.parentTitle}
      style={props.style}
      showCallout={props.showCallout ?? true}
    >
      <span
        className="kendo-custom-tooltip"
        title={props.title}
        style={{ display: "inherit", width: "100%" }}
      >
        {props.children}
      </span>
    </KendoToolTip>
  );
};

export default ToolTip;
